import type { ContentFile } from '@/types';

/** Who opened the lightbox — decides which actions `AppLightbox` offers. */
export enum LightboxSource {
  /** Creations grid, or a run auto-opened when it finished. */
  Creations = 'creations',
  /**
   * The creations grid a host mounts on its own (`./Creations` on gen.ai's
   * `/assets`): the full set minus Reuse template — there is no create screen
   * around the grid to reuse into.
   */
  HostCreations = 'host-creations',
  /** A `task_id` / `file_uid` deeplink's own results. */
  Deeplink = 'deeplink',
  /** Look-only preview (Dance tab motions): no actions. */
  Preview = 'preview',
}

export interface OpenLightboxParams {
  items: ContentFile[];
  /** Defaults to the first item. */
  index?: number;
  source: LightboxSource;
  /** Freshly-generated result: title bar, no prev/next, starts muted. */
  resultMode?: boolean;
}

export interface LightboxSlice {
  /**
   * What the single `AppLightbox` shows. A snapshot taken at open: the list it
   * came from can reload or grow underneath without swapping or closing the
   * open item. Empty = closed.
   */
  lightboxItems: ContentFile[];
  lightboxIndex: number;
  lightboxSource: LightboxSource;
  isLightboxResultMode: boolean;
  openLightbox: (params: OpenLightboxParams) => void;
  closeLightbox: () => void;
  setLightboxIndex: (index: number) => void;
  /** Keeps the snapshot in step with an edit to the same file (reactions). */
  updateLightboxItem: (params: {
    uuid: string;
    updates: Partial<ContentFile>;
  }) => void;
}
